module.exports = __webpack_public_path__ + "static/Verne7-9e09323d4f68e02392c1c3e87abc9729.png";